/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import {despachosRoute} from "../data.service";
import {segurosModuleName, segurosRoute} from "../../seguros/shared/data.service";
import {seguradorasModuleName, seguradorasRoute} from "../../seguradoras/shared/data.service";

@Component({
    selector: 'app-despacho-seguros-menu',
    template: require('./despacho-seguros-menu.component.html')
})
export class DespachoSegurosMenuComponent implements OnInit {
    despachosRoute: string = despachosRoute;
    seguradorasRoute: string = seguradorasRoute;
    segurosRoute: string = segurosRoute;

    seguradorasModule: any = seguradorasModuleName;
    segurosModule: any = segurosModuleName;

    constructor() { }

    ngOnInit() {
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/shared/despacho-seguros-menu/despacho-seguros-menu.component.ts
 **/